import MenuPointLine from "./menu-point-line.vue";
export default {
  name: "auth-menu-point-list",
  components: {
    MenuPointLine
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object,
      default: () => {
        return {};
      }
    },
    valueProperty: {
      type: String,
      default: 'individual_value'
    }
  },
  methods: {
    updateModelValue: function (value, key) {
      const model = JSON.parse(JSON.stringify(this.modelValue));
      model[key] = value;
      this.$emit('update:modelValue', model);
    }
  }
};